import { Component, OnInit } from '@angular/core';
import { DistributionHeaderComponent } from '../abstract-header/distribution-header.component';
import { ClaimsNetDistributionJob } from '../../../models/distribution-doc-models';
import { ClaimNetChannels, RecipientOptions } from '../../../models/recipient-options';
import { RecipientOptionsService, RecipientOptionsUriBuilderParams } from '../../../../core/services/recipient-options.service';
import { BaseWithIdList } from '../../../models/list';
import { OP } from '../../../../core/services/base/base-service-with-bundle.service';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'claims-net-distribution-header',
    templateUrl: './claims-net-distribution-header.component.html',
    styleUrls: ['./claims-net-distribution-header.component.scss']
})
export class ClaimsNetDistributionHeaderComponent extends DistributionHeaderComponent<ClaimsNetDistributionJob>
                                                  implements OnInit {

    public selectedRecipientOptions: UntypedFormControl;
    public claimsNetRecipientOptions: BaseWithIdList<RecipientOptions>;

    get job(): ClaimsNetDistributionJob {
        return this.bananaBox;
    }

    constructor(protected recipientOptionsService: RecipientOptionsService, public translateService: TranslateService) {
        super();
        this._idPrefix = 'claimnet.'
    }

    public ngOnInit() {
        super.ngOnInit();
        this.recipientOptionsService.query(new RecipientOptionsUriBuilderParams())
                                    .subscribe((result) => {
            this.claimsNetRecipientOptions = result;

            this.selectedRecipientOptions = new UntypedFormControl(
            {
                value: this.claimsNetRecipientOptions.getItem(this.job.distribution_option),
                disabled: this.disabled
            },
            {
                updateOn: 'change',
                validators: [Validators.required],
            });
        });
    }

    public updateRecipientOptions(): void {
        const patchData = [{
            op: this.selectedRecipientOptions.value && this.selectedRecipientOptions.value.id ? OP.replace : OP.remove,
            path: 'distribution_option',
            value: this.selectedRecipientOptions.value ? this.selectedRecipientOptions.value.id : undefined
        }, {
            op: this.selectedRecipientOptions.value && this.selectedRecipientOptions.value.recipient_name ? OP.replace : OP.remove,
            path: 'distribution_option_value',
            value: this.selectedRecipientOptions.value ? this.selectedRecipientOptions.value.recipient_name : undefined
        }, {
            op: this.selectedRecipientOptions.value && this.selectedRecipientOptions.value.channel ? OP.replace : OP.remove,
            path: 'sub_channel',
            value: this.selectedRecipientOptions.value ? this.selectedRecipientOptions.value.channel : undefined
        }, {
            op: this.selectedRecipientOptions.value && this.selectedRecipientOptions.value.channel ? OP.replace : OP.remove,
            path: 'sub_channel_value',
            value: this.selectedRecipientOptions.value && ClaimNetChannels.getByKey(this.selectedRecipientOptions.value.channel) ?
                       this.translateService.instant(ClaimNetChannels.getByKey(this.selectedRecipientOptions.value.channel).trans) : undefined
        }, {
            op: this.selectedRecipientOptions.value && this.selectedRecipientOptions.value.max_filesize ? OP.replace : OP.remove,
            path: 'max_filesize',
            value: this.selectedRecipientOptions.value ? this.selectedRecipientOptions.value.max_filesize : undefined
        }, {
            op: this.selectedRecipientOptions.value && this.selectedRecipientOptions.value.merge_documents ? OP.replace : OP.remove,
            path: 'merge_pdf',
            value: this.selectedRecipientOptions.value ? this.selectedRecipientOptions.value.merge_documents : undefined
        }, {
            op: this.selectedRecipientOptions.value && this.selectedRecipientOptions.value.remove_images ? OP.replace : OP.remove,
            path: 'print_remove_pictures',
            value: this.selectedRecipientOptions.value ? this.selectedRecipientOptions.value.remove_images : undefined
        }];

        this.onMultiUpdate(patchData);
    }

    public validate(): boolean {
        this.selectedRecipientOptions.markAsTouched();
        return this.selectedRecipientOptions.valid;
    }

    public isValid(): boolean {
        return true;

    }
}
